import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';

import { LINE_ITEM_CONTAINER_WIDTH } from '../../upsell.constants';

// ─────────────────────────────────────────────────────────────────────────────

export const UpsellLineItemContainer = (props: PropsWithChildren) => {
  return <View style={styles.container}>{props.children}</View>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    width: LINE_ITEM_CONTAINER_WIDTH,
    paddingTop: theme.spacing['12'],
  },
});
